var dgsDiscountSpecials30					= ["CJTWTM7K190Z"];
var dgsDiscountSpecials25					= [];
var dgsDiscountSpecials20					= [];
var dgsDiscountSpecials15					= ["NEU15"];

var dgsDiscountScripts						= {};

// Probenaktion
var scriptID = "248250634";
dgsDiscountScripts[scriptID] 				= {};
dgsDiscountScripts[scriptID]["codes"] 		= ['STEFANO','STEFANO10','SARAH','SARAH10'];
dgsDiscountScripts[scriptID]["tags"] 		= [];
dgsDiscountScripts[scriptID]["products"] 	= [5917182361764,5917182230692,7209208283300,7263407505572,6020815061156,5917182197924,5917181804708,6666426122404];
dgsDiscountScripts[scriptID]["types"] 		= ["percent","percent","percent","percent","percent","percent","percent","percent"];
dgsDiscountScripts[scriptID]["values"] 		= [25,25,25,25,25,25,25,25];
dgsDiscountScripts[scriptID]["specials"] 	= [];

